import { render, staticRenderFns } from "./ProjectUserCard.vue?vue&type=template&id=518c1bd4&"
import script from "./ProjectUserCard.vue?vue&type=script&lang=js&"
export * from "./ProjectUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports